export default "__VITE_ASSET__Ds0x_j6J__"